import DashboardPage from '@components/pages/dashboard'
import { ConfigurationsPageWrapper } from './fraud-defense.configurations.route.styles'
import { IntegrationsStore } from '@/core/store/Integrations'
import { FdConfigTable } from './FdConfigTable'

const ConfigurationsPage = () => {
    const fraudDefenseIntegrations =
        IntegrationsStore.getFraudDefenseIntegrations().filter(
            (integration) => integration.status !== 'inactive'
        )

    return (
        <ConfigurationsPageWrapper>
            <DashboardPage
                name="fraud-defense-configurations"
                hideScanInProgress
            >
                {fraudDefenseIntegrations.length > 0 && (
                    <FdConfigTable data={fraudDefenseIntegrations} />
                )}
            </DashboardPage>
        </ConfigurationsPageWrapper>
    )
}

export default ConfigurationsPage
